<script type="text/javascript">
	import Icon from "../icon.svelte";
	export let category = undefined, description = undefined, seller = undefined, rub = undefined, id = undefined;
	export let hoverable = true, loading = false;
	
	let href = "#";
	$: if (hoverable && !loading) href = "/product/"+id;
</script>
{#if loading}
	<div class={"product loading "+$$props.class}></div>
{:else}
<a class={"product "+$$props.class} class:hoverable href={href}>
	<div class="product-header">
		<img src={category.img}>
		<div>
			<span>{category.label}</span>
			<span>{category.sublabel}</span>
		</div>
	</div>
	<div class="product-description">
		<span>{description}</span>
	</div>
	<div class="product-footer">
		<div class="product-seller">
			<img class:verified={seller.verified} src={seller.ava} loading="lazy">
			<span>{seller.name}</span>
			{#if seller.verified}<div class="check"><Icon verified /></div>{/if}
		</div>
		<span class="product-price">{rub} &#8381;</span>
	</div>
</a>
	{/if}
<style>

	.product-footer{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.product-footer > .product-seller > img{
		width: 40px;
		height: 40px;
		object-fit: cover;
		border-radius: 50%;
		margin-right: 10px;
	}
	.product-footer > .product-seller > img.verified{
		border: 2px solid #AA59E4;

    	box-sizing: border-box;
	}
	.product-footer > .product-seller{
		display: flex;
		align-items: center;
	}
	.product-footer > .product-seller > div.check{
		margin-top: 8px;
		color: #AA59E4;
	}
	.product-footer > .product-seller > span{
		font-weight: 500;
		font-size: 16px;
		line-height: 20px;
	}

	.product-footer > .product-price{
		font-weight: 500;
		font-size: 18px;
		
		background: #39DA53;
		box-shadow: 0px 4px 9px rgba(57, 218, 83, 0.25);
		border-radius: 2px;
		display: block;
		padding: 2px 5px;
		box-sizing: border-box;
		color: #FFFFFF;
	}
	.product.hoverable, .product.hoverable > *, .product.hoverable > * > *{
		cursor: pointer;
	}
	.product.hoverable:hover{
		box-shadow: 0px 13px 27px rgba(152, 98, 197, 0.15);
		border-color: #9862C5;
	}
	.product.hoverable:active{
		box-shadow: 0px 13px 28px 1px rgba(157, 93, 210, 0.22);
	}
	.product{
		transition: all .1s linear;
		width: 100%;
		min-height: 250px;

		background: #0F131C;
		border: 1px solid #25253A;
		box-sizing: border-box;

		display: block;
		color: white;
		text-decoration: none;
		
		
		padding: 20px 15px; border-radius: 8px;
	}
	
	.product.loading{
		cursor: progress;
		background: rgba(41,51,72,.28);
		animation: loading 1.45s linear infinite;
		border: none;
	}

	.product > .product-description{
		
		color: rgba(255,255,255,.5);
		border-bottom: 1px solid rgba(255,255,255,.1);
		border-top: 1px solid rgba(255,255,255,.1);
		padding: 10px 0;
		border-bottom: 1px solid rgba(255,255,255,.1);
		margin-bottom: 10px;
		
	}
	.product > .product-description > span{
height: 75px;
		
		overflow-y: auto;
		display: flex;
		display: block;
	}

	.product-header{
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		
	}
	.product-header > div{
		display: flex;
		flex-direction: column;
	}
	.product-header > div > span:nth-child(1n){
		font-weight: bold;
		font-size: 24px;
		line-height: 30px;
		color: #FFFFFF;
	}
	.product-header > div > span:nth-child(2n){
		font-weight: normal;
		font-size: 18px;
		line-height: 23px;
		color: #9862C5;
	}

	.product-header > img{
		width: 50px;
		height: 50px;
		object-fit: cover;
		border-radius: 50%;
		margin-right: 10px;
	}
</style>